import { render, staticRenderFns } from "./GameDetailMenu.vue?vue&type=template&id=67e7b7ae&scoped=true&"
import script from "./GameDetailMenu.vue?vue&type=script&lang=js&"
export * from "./GameDetailMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameDetailMenu.vue?vue&type=style&index=0&id=67e7b7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7b7ae",
  null
  
)

export default component.exports